import { render, staticRenderFns } from "./school-form-page.vue?vue&type=template&id=87717b8e&scoped=true&"
import script from "./school-form-page.vue?vue&type=script&lang=js&"
export * from "./school-form-page.vue?vue&type=script&lang=js&"
import style0 from "./school-form-page.vue?vue&type=style&index=0&id=87717b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87717b8e",
  null
  
)

export default component.exports